"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.array.sort");
require("core-js/modules/es6.number.constructor");
var _payPopup = require("@/api/activity/payPopup");
var _sys_cons = require("@/api/sys_cons");
var _UploadImg = _interopRequireDefault(require("./UploadImg.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultForm = function defaultForm() {
  return {
    id: '',
    title: '',
    imageUrl: '',
    jumpUrl: '',
    jumpType: 1,
    triggerType: 1,
    money: 0,
    gradeRestriction: 1,
    gradeIdsArr: [],
    startTime: '',
    endTime: '',
    sort: 0,
    enabled: true
  };
};
var _default = exports.default = {
  name: 'PayPopupActivity',
  components: {
    PayPopupUploadImg: _UploadImg.default
  },
  data: function data() {
    var _this = this;
    return {
      imageAccessDomain: '',
      memberLevelOptions: [],
      searchForm: {
        title: '',
        enabled: '',
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      loading: false,
      dialogVisible: false,
      dialogTitle: '新增弹窗',
      dialogLoading: false,
      submitting: false,
      form: defaultForm(),
      rules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        triggerType: [{
          required: true,
          message: '请选择类型',
          trigger: 'change'
        }],
        jumpType: [{
          required: true,
          message: '请选择跳转类型',
          trigger: 'change'
        }],
        activeTimeRange: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!_this.form.startTime || !_this.form.endTime) {
              callback(new Error('请选择生效时间'));
            } else if (new Date(_this.form.endTime).getTime() < new Date(_this.form.startTime).getTime()) {
              callback(new Error('结束时间不能早于开始时间'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    activeTimeRange: {
      get: function get() {
        return this.form.startTime && this.form.endTime ? [this.form.startTime, this.form.endTime] : [];
      },
      set: function set(val) {
        this.form.startTime = val && val[0] ? val[0] : '';
        this.form.endTime = val && val[1] ? val[1] : '';
      }
    }
  },
  created: function created() {
    this.fetchImageDomain();
    this.fetchMemberLevels();
    this.fetchList();
  },
  methods: {
    fetchImageDomain: function fetchImageDomain() {
      var _this2 = this;
      (0, _sys_cons.queryImageAccessDomain)().then(function (res) {
        if (res.code === 200 && res.data) {
          _this2.imageAccessDomain = res.data;
        }
      });
    },
    fetchMemberLevels: function fetchMemberLevels() {
      var _this3 = this;
      (0, _sys_cons.queryMemberLevelCombo)().then(function (res) {
        if (res.code === 200 && res.data) {
          _this3.memberLevelOptions = res.data;
        }
      });
    },
    fetchList: function fetchList() {
      var _this4 = this;
      this.loading = true;
      (0, _payPopup.queryPayPopupActivityPage)(this.searchForm).then(function (res) {
        if (res.code === 200) {
          _this4.tableData = res.records || [];
          _this4.searchForm.total = res.total || 0;
        } else {
          _this4.$message.error(res.message || '查询失败');
        }
      }).finally(function () {
        _this4.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.fetchList();
    },
    handleReset: function handleReset() {
      this.searchForm.title = '';
      this.searchForm.enabled = '';
      this.searchForm.page = 1;
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.searchForm.limit = size;
      this.fetchList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.searchForm.page = page;
      this.fetchList();
    },
    handleAdd: function handleAdd() {
      this.dialogTitle = '新增弹窗';
      this.form = defaultForm();
      this.dialogVisible = true;
    },
    handleEdit: function handleEdit(row) {
      var _this5 = this;
      this.dialogTitle = '编辑弹窗';
      this.dialogVisible = true;
      this.dialogLoading = true;
      (0, _payPopup.queryPayPopupActivity)(row.id).then(function (res) {
        if (res.code === 200 && res.data) {
          _this5.applyEntityToForm(res.data);
        } else {
          _this5.$message.error(res.message || '查询明细失败');
        }
      }).finally(function () {
        _this5.dialogLoading = false;
      });
    },
    handleDelete: function handleDelete(row) {
      var _this6 = this;
      this.$confirm("\u786E\u5B9A\u5220\u9664\u300C".concat(row.title, "\u300D\u5417\uFF1F"), '提示', {
        type: 'warning'
      }).then(function () {
        (0, _payPopup.delPayPopupActivity)(row.id).then(function (res) {
          if (res.code === 200) {
            _this6.$message.success('删除成功');
            _this6.fetchList();
          } else {
            _this6.$message.error(res.message || '删除失败');
          }
        });
      }).catch(function () {});
    },
    handleDialogClosed: function handleDialogClosed() {
      var _this7 = this;
      this.form = defaultForm();
      this.$nextTick(function () {
        if (_this7.$refs.formRef) {
          _this7.$refs.formRef.clearValidate();
        }
      });
    },
    applyEntityToForm: function applyEntityToForm(entity) {
      var f = defaultForm();
      f.id = entity.id;
      f.title = entity.title;
      f.imageUrl = entity.imageUrl || '';
      f.jumpUrl = entity.jumpUrl || '';
      f.jumpType = entity.jumpType || 1;
      f.triggerType = entity.triggerType || 1;
      f.money = Number(entity.money || 0);
      f.gradeRestriction = entity.gradeRestriction || 1;
      f.startTime = entity.startTime || '';
      f.endTime = entity.endTime || '';
      f.sort = Number(entity.sort || 0);
      f.gradeIdsArr = entity.gradeIds ? entity.gradeIds.split(',').map(function (s) {
        return Number(s.trim());
      }).filter(function (v) {
        return !isNaN(v);
      }) : [];
      f.enabled = !!entity.enabled;
      this.form = f;
    },
    buildEntity: function buildEntity() {
      var f = this.form;
      var entity = {
        id: f.id || undefined,
        title: f.title,
        imageUrl: f.imageUrl,
        jumpUrl: f.jumpType === 2 ? f.jumpUrl : '',
        jumpType: f.jumpType,
        triggerType: f.triggerType,
        money: f.money,
        gradeRestriction: f.gradeRestriction,
        gradeIds: f.gradeRestriction === 2 ? (f.gradeIdsArr || []).join(',') : '',
        startTime: f.startTime,
        endTime: f.endTime,
        sort: f.sort,
        enabled: f.enabled
      };
      return entity;
    },
    handleSubmit: function handleSubmit() {
      var _this8 = this;
      if (this.form.jumpType === 2 && !this.form.jumpUrl) {
        this.$message.warning('请输入跳转路径');
        return;
      }
      if (this.form.triggerType === 1 && (!this.form.money || this.form.money <= 0)) {
        this.$message.warning('请输入账单金额阈值');
        return;
      }
      if (this.form.triggerType === 2 && (!this.form.money || this.form.money <= 0)) {
        this.$message.warning('请输入实付金额阈值');
        return;
      }
      if (this.form.gradeRestriction === 2 && (!this.form.gradeIdsArr || this.form.gradeIdsArr.length === 0)) {
        this.$message.warning('请选择适用会员等级');
        return;
      }
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        _this8.submitting = true;
        var entity = _this8.buildEntity();
        var action = entity.id ? (0, _payPopup.updatePayPopupActivity)(entity) : (0, _payPopup.addPayPopupActivity)(entity);
        action.then(function (res) {
          if (res.code === 200) {
            _this8.$message.success(entity.id ? '修改成功' : '保存成功');
            _this8.dialogVisible = false;
            _this8.fetchList();
          } else {
            _this8.$message.error(res.message || '保存失败');
          }
        }).finally(function () {
          _this8.submitting = false;
        });
      });
    },
    formatJumpType: function formatJumpType(type) {
      if (type === 1) return '不跳转';
      if (type === 2) return '点餐';
      return '-';
    },
    jumpTagType: function jumpTagType(type) {
      if (type === 2) return 'success';
      return 'info';
    },
    formatTriggerType: function formatTriggerType(type) {
      if (type === 1) return '账单金额';
      if (type === 2) return '实付金额';
      return '-';
    },
    triggerTagType: function triggerTagType(type) {
      if (type === 2) return 'warning';
      if (type === 3) return 'success';
      return 'primary';
    },
    formatAmountRule: function formatAmountRule(row) {
      if (row.triggerType === 1) {
        return "\u8D26\u5355\u91D1\u989D ".concat(row.moneyCompare || '>=', " ").concat(row.money || 0, "\u5143");
      }
      if (row.triggerType === 2) {
        return "\u5B9E\u4ED8\u91D1\u989D ".concat(row.moneyCompare || '>=', " ").concat(row.money || 0, "\u5143");
      }
      return '<span class="muted">未配置</span>';
    },
    formatGradeRule: function formatGradeRule(row) {
      if (!row.gradeRestriction || row.gradeRestriction === 1) return '全部等级';
      if (!row.gradeIds) return '-';
      var map = {};
      this.memberLevelOptions.forEach(function (o) {
        map[Number(o.value)] = o.label;
      });
      return row.gradeIds.split(',').map(function (s) {
        return map[Number(s.trim())] || s.trim();
      }).join('、');
    }
  }
};